const API_URL = 'https://api.goodhood.sg/ncov2019'
// const API_URL = 'http://localhost:3005'

export {
    API_URL
}